import "./Contact.css";
import Header from "../Shared/Header/Header";
import ContactUs from "../Home/ContactUs/ContactUs";
import Footer from "../Shared/Footer/Footer";
import SubHeader from '../Shared/SubHeader/SubHeader';

const Contact = () => {
  return (
    <>
      <Header />
      <SubHeader title="Kontakt" 
        subtitle="Pozostajemy do Twojej dyspozycji – z troską i pełnym zaangażowaniem." 
      />
      <section className="contact-section px-4 py-8 text-left text-gray-700">
        <p className="mb-2">
          <strong>Email:</strong> kontakt@synavie.pl
        </p>
        <p className="mb-2">
          <strong>Adres:</strong> ul. Natolińska 3/24, 00-564 Warszawa
        </p>
        <p className="mb-2">
          <strong>KRS:</strong> 0001163475
        </p>
        <p className="mb-2">
          <strong>NIP:</strong> 7011252192
        </p>
      </section>

      <ContactUs />
      <Footer />
    </>
  );
};

export default Contact;
